import React from 'react';
import InfoIcon from '@mui/icons-material/Info';
import { Typography } from '@mui/material';
import { Popup } from '@elements';
import { StyledContent, StyledHeader } from './info.styles';
/**
 * InfoPopup component.
 *
 * @author Mikhail Siutsou
 * @function InfoPopup
 * @category components
 * @param {PopupProps} popup props.
 * @return {FC} popup component.
 */

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var InfoPopup = function InfoPopup(_ref) {
  var popUp = _ref.popUp;
  // ToDo: get info text from server or other source
  var header = popUp && popUp.data && popUp.data.header;
  var body = popUp && popUp.data && popUp.data.body;
  return /*#__PURE__*/_jsxs(Popup, {
    width: 422,
    fullWidth: true,
    popUp: popUp,
    children: [/*#__PURE__*/_jsx(Popup.Title, {
      children: /*#__PURE__*/_jsx(StyledHeader, {
        children: /*#__PURE__*/_jsx(InfoIcon, {
          fontSize: "large",
          color: "warning",
          sx: {
            height: 48,
            width: 48
          }
        })
      })
    }), /*#__PURE__*/_jsx(Popup.Content, {
      children: /*#__PURE__*/_jsxs(StyledContent, {
        flexDirection: "column",
        children: [header && /*#__PURE__*/_jsx(Typography, {
          color: "textPrimary",
          variant: "h4",
          textAlign: "center",
          children: header
        }), body && /*#__PURE__*/_jsx(Typography, {
          color: "textPrimary",
          variant: "body1",
          textAlign: "center",
          pt: header ? 2 : undefined,
          children: body
        })]
      })
    })]
  });
};

export { InfoPopup };